import { useDispenseLimitExceededActions } from '@/components/Patient/hooks/useDispenseLimitExceededActions';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useDispenseLimitAnalytics } from './useDispenseLimitExceededTracking';

export const DispenseLimitExceededAlert = () => {
  const { showAlert } = useDispenseLimitExceededActions();
  const { trackDispenseLimitEvent, resetTracking } = useDispenseLimitAnalytics();

  if (showAlert) {
    trackDispenseLimitEvent();
  } else {
    resetTracking();
  }

  if (!showAlert) {
    return null;
  }

  return (
    <Snackbar
      open={true}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Alert severity="warning">
        <AlertTitle>Prescription exceeds 100g dried herb</AlertTitle>
        This is above the recommended amount and may cause delays in dispensing.
      </Alert>
    </Snackbar>
  );
};
